import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import InputUtils, {Type} from "../../../../../../InputUtils";
import './createRoleModalStyles.css'
import Utils from "../../../../../../Utils";

interface Props {
    createRole(role): void,

    editRole(dto): void,

    restoreEventListener(): void,

    hideModal(): void,

    showModal: boolean,
    selectedRole: any,
    modalData: any,
}

interface State {
    validateForm: boolean;
    formIsValid: boolean;
    form: any,
}

enum DEFAULT_ERROR_MSG {
    ROLE_NAME = 'Name field cannot be empty',
}

class CreateRoleModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            validateForm: false,
            formIsValid: true,
            form: {
                roleName: {
                    value: '',
                    valid: true,
                    errorMsg: DEFAULT_ERROR_MSG.ROLE_NAME
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
            this.resetForm();
            document.addEventListener('keydown', this.keydownModalHandler);
            setTimeout(() => {
                this.loadDataToForm();
            }, 100);
        }
        if (this.props.showModal !== prevProps.showModal && !this.props.showModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13) {
            Utils.$('#btn-save').click();
        }
    }

    loadDataToForm = () => {
        let formCopy = JSON.parse(JSON.stringify(this.state.form));
        if (this.props.selectedRole) {
            const selectedRole = JSON.parse(JSON.stringify(this.props.selectedRole));
            const keys = Object.keys(selectedRole);

            keys.forEach(key => {
                if (formCopy.hasOwnProperty(key)) {
                    formCopy = {
                        ...formCopy,
                        [key]: {
                            ...formCopy[key],
                            value: selectedRole[key] ? selectedRole[key] : ''
                        }
                    }
                }
            })
        }
        this.setState({
            form: formCopy
        })
    }

    open = () => {
        this.resetForm();
        this.setState({
            formIsValid: true,
            validateForm: false,
        });
    };

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    close = () => {
        this.resetForm();
        this.props.hideModal();
        this.props.restoreEventListener()
    };

    onChange = (event, id, inputType) => {
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let eventValue;
        if (inputType.includes('select')) {
            eventValue = event ? event : [];

        } else {
            eventValue = event.target.value;
        }
        this.setValueToForm(formCopy, id, eventValue);
    }

    setValueToForm = (formCopy: any, id: string, eventValue: any, errorMsg?: any) => {
        if (errorMsg) {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: false,
                        errorMsg: errorMsg
                    }
                }
            })
        } else {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: true,
                        errorMsg: this.getDefaultErrorMsg(id)
                    }
                }
            })
        }
    }

    getDefaultErrorMsg = (id: string) => {
        if (id === 'roleName') {
            return DEFAULT_ERROR_MSG.ROLE_NAME;
        }
    }

    createRoleHandler = () => {
        if (this.checkFormValidity()) {
            if (this.props.selectedRole) {
                this.props.editRole({
                    roleId: this.props.selectedRole.roleId,
                    roleName: this.state.form.roleName.value,
                })
            } else {
                const dto = {
                    roleName: this.state.form.roleName.value,
                }
                this.props.createRole(dto)
            }
            this.props.restoreEventListener()
        }
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            if (key === 'roleName') {
                if ((formCopy[key].value === '' || this.checkIsNameUnique(formCopy[key].value)) || !formCopy[key].valid) {
                    formCopy[key].valid = false;
                    if (formCopy[key].value !== '') {
                        formCopy[key].errorMsg = `${formCopy[key].value} is already used`;
                    }
                    formIsValid = false;
                }
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    checkIsNameUnique = (name: string) => {
        if (this.props.modalData.usedNames.length > 0) {
            if (this.props.selectedRole &&
                this.props.selectedRole.roleName === this.state.form.roleName.value) {
                return false;
            }
            return this.props.modalData.usedNames.includes(name);
        }
        return false;
    }


    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 600,
                        padding: 0,
                        maxWidth: 600,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-role-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-role-modal-header'}>
                                <h2>{this.props.selectedRole ? 'Edit Role' : 'Create Role'}</h2>
                            </header>
                            <div className={'create-role-modal-container'}>
                                <div className={'createRoleForm'}>
                                    <Input id={'roleName'}
                                           value={this.state.form.roleName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'roleName', 'input')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.roleName.valid}
                                           errorMsg={this.state.form.roleName.errorMsg}
                                           label={'Role Name'}
                                           elementConfig={{
                                               placeholder: 'Role Name',
                                               tabIndex: 1
                                           }}
                                    />
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.createRoleHandler}
                                    className={"btn"}
                                    id={'btn-save'}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-save"> Save</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default CreateRoleModal



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/RolesGrid/components/createUserModal/CreateRoleModal.tsx